var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cooperation"},[_c('div',{staticClass:"title"},[_vm._v("合作律所")]),_c('div',{staticClass:"cooperation-view"},_vm._l((_vm.cooperation_list),function(val,ind){return _c('el-image',{key:ind,staticClass:"cooperation-view-img",attrs:{"src":val,"fit":"contain"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }